<template>
  <div class="PeriodicalDetail">
    <!-- 内容层开始 -->
    <div class="box" ref="container">
      <div class="box_title">
        <van-image class="img" :src="detail.defaultImage" fit="cover"></van-image>
      </div>
      <div class="box_content">
        <div class="title">{{ detail.title }}</div>
        <div class="text">
          <span class="text_title">活动时间</span>
          <span class="text_content">{{ detail.startDate | formatDate('yyyy-MM-dd') }} - {{ detail.endDate | formatDate('yyyy-MM-dd') }}</span>
        </div>
        <div class="message">{{ detail.brief }}</div>
        <div class="bottom">
          <div class="price">
            <template v-if="!detail.free">
              ￥<span class="big">{{ detail.price | toFixed }}</span>
            </template>
            <template v-else>
              <span class="big">免费</span>
            </template>
          </div>
          <template  v-if="detail.status == 1">
            <div class="btn btn_01" @click="show=true">已投稿</div>
          </template>
          <template  v-else>
            <div class="btn btn_01" @click="show=true" v-if="detail.activityStatus===3">我要投稿</div>
            <div class="btn btn_02" v-if="detail.activityStatus===2">已结束</div>
          </template>
        </div>
      </div>
      <div class="box_bottom">
        <div class="title">活动详情</div>
        <div class="message rich-text" v-html="detail.content"></div>
        <div class="btnBotom" @click="show=true" v-if="detail.activityStatus===3">我要投稿</div>
      </div>
    </div>
    <!-- 内容层结束 -->

    <!-- 移动弹窗开始 -->
      <van-popup
      v-model="show"
      :closeable="false"
      position="center"
      :style="{ width: '80%'}"
      class="popup"
    >
      <div class="box">
        <div class="box_title">移动端不支持投稿</div>
        <div class="box_nav">请复制链接到PC端进行投稿</div>
        <div class="message">
          <div class="linkTo" ref="link">{{pcUrl}}</div>
          <div class="text"><span class="bold">研究在线>热门活动</span> 查找您需要投稿的活动项目。</div>
        </div>
        <div class="box_bottom">
          <div class="btn btn_01" @click="copyLink">复制链接</div>
          <div class="btn btn_02" @click="show=false">知道了</div>
        </div>
      </div>
    </van-popup>
    <!-- 移动弹窗结束 -->
  </div>
</template>

<script>
export default {
  name: 'PeriodicalDetail',
  data () {
    return {
      show: false,
      detail: {}
    };
  },
  watch: {
    $route: {
      handler ({ name, params: { id } }) {
        if (name === 'PeriodicalDetail') {
          this.getDetail(id);
        }
      },
      immediate: true
    }
  },
  computed: {
    pcUrl () {
      return location.origin + '/studyOnlineModel/essayActivity/detail/' + this.detail.id;
    }
  },
  methods: {

    /* 获取详情数据 */
    getDetail (id) {
      this.$http.get('solicit/detail', { params: { id }, showLoading: true }).then((res) => {
        this.detail = res.data.detail;
        this.$route.meta.title = this.detail.title || '详情';
        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: this.detail.title, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.detail.brief || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: this.detail.defaultImage // 图片, 默认取网页中第一个img标签
        });
      });
    },

    /* 复制链接 */
    copyLink () {
      const { $utils } = this;
      $utils.copyValueToClipBoard(this.pcUrl).then(async () => {
        $utils.successToast({
          message: '复制成功!',
          onClose: () => {
            this.show = false;
          }
        });
      }, () => {
        $utils.failToast('复制失败!');
      });
    }
  }
};
</script>

<style scoped lang="less">
  .PeriodicalDetail {
    min-height: calc(100vh - 96px);
    background-color: #fff;
    padding-bottom: 40px;
    .box {
      .box_title{
        width: 100%;
        .img{
          width: 100%;
          height: 500px;
        }
      }
      .box_content{
        background: #FFFFFF;
        border-radius: 28px 28px 0px 0px;
        padding: 56px 28px;
        position: relative;
        top: -18px;
        border-bottom: 20px solid #F9FAFC;
        .title{
          font-size: 36px;
          font-weight: bold;
          line-height: 56px;
          color: #333444;
          margin-bottom: 56px;
        }
        .text{
          font-size: 24px;
          line-height: 48px;
          color: #FFFFFF;
          margin-bottom: 28px;
          .text_title{
            background: #67677A;
            border-radius: 8px 0px 0px 8px;
            padding: 8px 16px;
          }
          .text_content{
            padding: 6px 20px;
            border: 1px solid #67677A;
            border-radius: 0px 8px 8px 0px;
            color: #67677A;
          }
        }
        .message{
          font-size: 26px;
          line-height: 48px;
          color: #67677A;
          margin-bottom: 52px;
        }
        .bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price{
            font-size: 28px;
            font-weight: bold;
            color: #FF485D;
            .big{
              font-size: 40px;
            }
          }
          .btn{
            border-radius: 36px;
            font-size: 26px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            padding: 14px 38px;
            &.btn_01{
              background: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
              box-shadow: 0px 6px 12px rgba(255, 103, 97, 0.2);
            }
            &.btn_02{
              background: #DDDEE6;
            }
          }
        }
      }
      .box_bottom{
        margin-top: 40px;
        padding: 0 28px;
        .title {
          font-size: 36px;
          font-weight: bold;
          margin-bottom: 30px;
        }
        .btnBotom{
          width: 100%;
          border-radius: 72px;
          font-size: 26px;
          margin-top: 60px;
          height: 88px;
          line-height: 88px;
          background: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
          box-shadow: 0 0.08rem 0.16rem rgb(255 103 97 / 20%);
          color: #FFFFFF;
          text-align: center;
        }
      }
    }

    .popup{
      border-radius: 28px;
      .box{
        padding: 60px 40px 40px;
        .box_title{
          font-size: 36px;
          font-weight: bold;
          line-height: 48px;
          color: #333444;
          margin-bottom: 10px;
        }
        .box_nav{
          font-size: 26px;
          line-height: 48px;
          color: #999AAA;
          margin-bottom: 40px;
        }
        .message{
          background: #F9FAFC;
          border-radius: 20px;
          padding: 28px;
          margin-bottom: 40px;
          .linkTo{
            font-size: 26px;
            line-height: 48px;
            color: #333444;
          }
          .text{
            font-size: 26px;
            line-height: 48px;
            color: #999AAA;
            .bold{
              color: #333444;
              font-weight: bold;
            }
          }
        }
        .box_bottom{
          text-align: center;
          .btn{
            font-size: 26px;
            line-height: 48px;
            padding: 22px 0;
            &.btn_01{
              background: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
              box-shadow: 0px 6px 12px rgba(255, 103, 97, 0.2);
              color: #FFFFFF;
              border-radius: 40px;
            }
            &.btn_02{
              font-size: 26px;
              line-height: 48px;
              color: #67677A;
            }
          }
        }
      }
    }
  }
</style>
